<template>
  <div class="mt-2">
    <WarningDisable permission="app_install" />
    <div class="flex gap-6">
      <div>
        <form
          ref="status_form"
          class="mb-4 space-y-4"
          @submit="submit_without_reloading"
          @reset="keyword = undefined"
        >
          <div class="space-y-2">
            <div>
              <legend>Từ khóa</legend>
              <label class="input w-full md:w-fit 2xl:w-fit">
                <i
                  class="fa-solid fa-magnifying-glass text-base-content/80"
                ></i>
                <input
                  type="text"
                  placeholder="Tìm kiếm theo từ khóa"
                  name="keyword"
                  v-model="keyword"
                />
              </label>
            </div>
          </div>
          <div class="flex flex-wrap gap-2">
            <input
              class="btn btn-outline grow"
              type="reset"
              value="&#8635; Đặt lại"
              :disabled="apps_store.loading.get_installed_apps"
            />
            <button
              class="btn btn-primary btn-outline grow"
              type="submit"
              :disabled="
                !filter_has_changed || apps_store.loading.get_installed_apps
              "
            >
              &#10003; Áp dụng
            </button>
          </div>
        </form>
      </div>

      <div class="flex grow flex-col overflow-x-auto">
        <div class="text-base-content/80 mb-2 text-xl font-bold">
          Danh sách ứng dụng đã cài đặt
        </div>
        <Loading v-if="apps_store.loading.get_installed_apps" />
        <template v-else-if="apps_store.total_filter > 0">
          <div class="bg-base-100 mb-4 overflow-x-auto">
            <table class="table-pin-rows table-md table">
              <thead>
                <tr>
                  <th></th>
                  <th>Tên ứng dụng</th>
                  <th>Đường dẫn</th>
                  <th>Thời gian cài đặt</th>
                  <th>Thời gian tạo</th>
                  <th>Thời gian sửa đổi</th>
                </tr>
              </thead>
              <tbody class="bg-base-200">
                <tr
                  v-for="(app, idx) in apps_store.installed_apps"
                  :key="app.id"
                >
                  <th>
                    {{
                      idx +
                      1 +
                      (number_from_query("page", 1) - 1) *
                        number_from_query("size", 24)
                    }}
                  </th>
                  <td>{{ app.name }}</td>
                  <td>{{ app.path }}</td>
                  <td>
                    <span v-if="app.time_installed">{{
                      dayjs(app.time_installed * 1000).fromNow()
                    }}</span>
                    <span v-else class="text-base-content/20"> N/A </span>
                  </td>
                  <td>{{ dayjs(app.created).fromNow() }}</td>
                  <td>{{ dayjs(app.modified).fromNow() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :total_pages="apps_store.total_pages" />
        </template>
        <NotFound v-else />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { number_from_query, str_from_query } from "@/api";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import WarningDisable from "../WarningDisable.vue";
import { use_installed_apps } from "./useAppInstalled";

const init_keyword = computed(() => str_from_query("keyword"));

const keyword = ref<string | undefined>(init_keyword.value);
const filter_has_changed = computed(() => keyword.value !== init_keyword.value);
const apps_store = use_installed_apps();

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
    },
  });
};
</script>
